import { entityMetadata } from '../../../../app.module';
import { EntityDefinitionService, EntityDataService } from '@ngrx/data';
import { NgModule } from '@angular/core';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, DecimalPipe } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { CRMRoutingModule } from './crm-routing.module';
import { FasttrackPromotionLogsComponent } from './fasttrack-promotion-logs/fasttrack-promotion-logs.component';
import { FasttrackPromotionLogsDataService } from './fasttrack-promotion-logs/services/fasttrack-promotion-logs-data.service';
import { SmarticoPromotionLogsComponent } from './smartico-promotion-logs/smartico-promotion-logs.component';
import { SmarticoPromotionLogEntityService } from './smartico-promotion-logs/services/smartico-promotion-log-entity.service';
import { SmarticoPromotionLogDataService } from './smartico-promotion-logs/services/smartico-promotion-log-data.service';
import { CoreModule } from '@core/core.module';
import { FasttrackActivityLogsComponent } from './fasttrack-activity-logs/fasttrack-activity-logs.component';
import { FasttrackActivityLogsDataService } from './fasttrack-activity-logs/services/fasttrack-activity-logs-data.service';

@NgModule({
  declarations: [
    SmarticoPromotionLogsComponent,
    FasttrackPromotionLogsComponent,
    FasttrackActivityLogsComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    CRMRoutingModule,
    ReactiveFormsModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    NgxDaterangepickerMd.forRoot(),
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    CoreModule,
  ],
  providers: [
    DecimalPipe,
    SmarticoPromotionLogEntityService,
    SmarticoPromotionLogDataService,
    FasttrackPromotionLogsDataService,
    FasttrackActivityLogsDataService,
  ]
})
export class CRMModule {
  constructor(
    private eds: EntityDefinitionService,
    private entityDataService: EntityDataService,
    private smarticoPromotionLogDataService: SmarticoPromotionLogDataService,
  ) {
    eds.registerMetadataMap(entityMetadata);
  }
 }
